
import * as angular from "angular";

import { UserPreferencesService } from "./service/userpreferences.service";
import { UserPreferencesDirective } from "./userpreferences.directive";

angular
    .module("app.userpreferences", ["ngMaterial"])
    .service("userPreferencesService", UserPreferencesService)
    .directive("userPreferences", UserPreferencesDirective.factory());
